import { useEffect, useState } from 'react';

// Reactive viewport media query hook (responds to resize and rotation).
const useMediaQuery = (query) => {
	const [ matches, setMatches ] = useState(() => window.matchMedia(query).matches);

	useEffect(() => {
		const mql     = window.matchMedia(query),
			  handler = (e) => setMatches(e.matches);

		setMatches(mql.matches);
		mql.addEventListener('change', handler);
		return () => mql.removeEventListener('change', handler);
	}, [ query ]);

	return matches;
};

export default useMediaQuery;
